import { useState } from 'react';
import { motion } from 'framer-motion';
import { AiFillEye, AiFillGithub } from 'react-icons/ai';
import { urlFor } from '../client';

const Projects = ({
  id,
  imgUrl,
  name,
  projectLink,
  codeLink,
  title,
  description,
  tags,
  skillsTag,
  skills,
}) => {
  const [show, setShow] = useState(false);
  const handleClick = (e) => {
    if (e.target.value) {
      setShow(!show);
    }
  };

  const getSkillImage = (skillName) => {
    const skill = skills.find(
      (skill) => skill.name?.toLowerCase() === skillName?.toLowerCase(),
    );
    return skill;
  };

  return (
    <div className="app__work-item app__flex" key={id}>
      <div className="app__work-img app__flex">
        <img src={urlFor(imgUrl)} alt={name} className="bg-cover" />

        <motion.div
          whileHover={{ opacity: [0, 1] }}
          transition={{
            duration: 0.25,
            ease: 'easeInOut',
            staggerChildren: 0.5,
          }}
          className="app__work-hover app__flex"
        >
          <a href={projectLink} target="_blank" rel="noreferrer">
            <motion.div
              whileInView={{ scale: [0, 1] }}
              whileHover={{ scale: [1, 0.9] }}
              transition={{ duration: 0.25 }}
              className="app__flex"
            >
              <AiFillEye />
            </motion.div>
          </a>
        </motion.div>
      </div>
      <div className="app__work-content app__flex">
        <h4 className="bold-text uppercase pt-5">{title}</h4>
        <motion.p
          className="p-text desc"
          initial={{ opacity: 0, height: 40 }}
          animate={{ opacity: 1, height: show ? 'auto' : 40 }}
          transition={{ duration: 0.3 }}
        >
          {show ? description : description.substring(0, 120)}
        </motion.p>
        <div
          className={`flex max-sm:flex-col items-center ${codeLink ? 'justify-around' : 'justify-center'} align-center w-full`}
        >
          <button
            type="button"
            className={`${codeLink ? '' : ''}btn hover:scale-105`}
            value={id}
            onClick={(e) => handleClick(e)}
          >
            Read
            {!show ? ' more' : ' less'}{' '}
          </button>
          {codeLink && (
            <button type="button" className="">
              <a href={codeLink} target="_blank" rel="noreferrer">
                <motion.div
                  whileInView={{ scale: [0.5, 1.02] }}
                  whileHover={{ scale: [0.3, 1.02] }}
                  transition={{ duration: 0.25 }}
                  className="app__flex btn "
                >
                  <AiFillGithub className="mr-2" /> GitHub
                </motion.div>
              </a>
            </button>
          )}
        </div>
        <div className="app__work-tag app__flex">
          {skillsTag?.map((skillName) => {
            const image = getSkillImage(skillName);

            return (
              <div key={skillName}>
                {image && (
                  <img
                    src={urlFor(image.icon)}
                    alt={skillName}
                    className="w-9 h-9 mx-2 bg-white hover:scale-125 duration-300 transition-all ease-in
                  "
                  />
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Projects;
